import { render } from "./ArtworkSlider.vue?vue&type=template&id=77507296&ts=true"
import script from "./ArtworkSlider.vue?vue&type=script&lang=ts"
export * from "./ArtworkSlider.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__